import * as React from "react";
import AccountingTable from "../common/AccountingTable2CE";
import { BankDetailConstants as Constants } from "../constants";

type EditableAccountLine = {
    label: string,
    amount: string,
    className: string,
    link: string,
    edit: boolean
}

const Format : EditableAccountLine[] = [
    {"label":Constants.LIAB_ADMIN,"amount":"0", "className":"","link":"","edit": false},
    {"label":Constants.LIAB_SUBROGATED,"amount":"0", "className":"","link":"","edit": true}, // 937667
    {"label":Constants.LIAB_UNINSURED,"amount":"0", "className":"","link":"","edit": false},
    {"label":Constants.LIAB_OTHER,"amount":"0", "className":"","link":"","edit": true},
    {"label":Constants.LIAB_UNPROVEN,"amount":"0", "className":"sumRow","link":"3","edit": true},
    {"label":Constants.LIAB_TOTALLIAB,"amount":"0", "className":"bold","link":"4","edit": false}, 
    {"label":Constants.LIAB_NET,"amount":"0", "className":"sumRow bold","link":"","edit": false}
];

interface LiabTableProps {
    admin: string;
    subrogated: string;
    uninsured: string;
    other: string;
    unproven: string;
    totalLiab: string;
    net: string;
    total: string;
}
// eslint-disable-next-line
class LiabTable extends React.Component<LiabTableProps, any> {
    // eslint-disable-next-line
    constructor(props: LiabTableProps) {
        super(props);
    }

    render() {
        let data : EditableAccountLine[] = Format;
        
        data[0].amount = this.props.admin || "0";
        data[1].amount = this.props.subrogated || "0";
        data[2].amount = this.props.uninsured || "0";
        data[3].amount = this.props.other || "0";
        data[4].amount = this.props.unproven || "0";
        data[5].amount = this.props.totalLiab || "0";
        data[6].amount = this.props.net || "0";

      
        return(
            <React.Fragment>
                <AccountingTable 
                    headers={Constants.LIAB_HEADER} 
                    data={data} 
                    totalLabel={Constants.LIAB_TOTAL}
                    totalAmount={this.props.total}
                    idkey="liab"
                />
            </React.Fragment>
        )
    }
}

export default LiabTable;